/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { AccountManagerShowResponse } from './AccountManagerShowResponse';

export type AccountManagerShowResponseApiRespoonse = {
    data?: AccountManagerShowResponse;
    status?: AccountManagerShowResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace AccountManagerShowResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

